var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',[_c('div',[_c('span',{staticClass:"ml-1"},[_vm._v("SKL © 2020")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }